module.exports = __webpack_public_path__ + "img/theme_bright.8256ac.svg";